export interface IQuestionPackageState {
  error: string | null;
  saving: boolean;
  fetching: boolean;
  questionsPackages: string[];
}

export const initialState: IQuestionPackageState = {
  error: null,
  saving: false,
  fetching: false,
  questionsPackages: []
};
